import vars from '../helpers';

$('.intro__persons a, .intro__names a, .intro__arrow a').on('click', (e) => {
	let offset = 0;

	if (vars.isMobile()) {
		offset = 0 - $('.header').outerHeight() - 15;
	}

	let currentOffset = $($(e.currentTarget).attr('href')).offset().top;

	const scrollContainer = window.Scrollbar.get($('.js-scroller').get(0));

	e.preventDefault();
	if (scrollContainer) {
		scrollContainer.scrollTo(0, scrollContainer.offset.y + currentOffset, 1500);
	} else {
		vars.scrollTo($($(e.currentTarget).attr('href')), 500, offset);
	}
});
